import { lazy, Suspense, type ReactElement } from "react";
import { Route } from "react-router";

import { RouteFallback } from "../components/route-fallback";

const ToolsListPage = lazy(() =>
  import("./pages/ToolsListPage").then((m) => ({ default: m.ToolsListPage })),
);

function withSuspense(node: ReactElement): ReactElement {
  return <Suspense fallback={<RouteFallback />}>{node}</Suspense>;
}

export function toolsRoutes() {
  return <Route path="tools" element={withSuspense(<ToolsListPage />)} />;
}
